import Component from '../core/Component'

export default class CopyToClipboard extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            input: null,
            tooltip: null
        }
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        event.preventDefault();

        if (this.isIOS()) {
            const range = document.createRange()
            range.selectNodeContents(this.ref.input)
            const selection = window.getSelection()
            selection.removeAllRanges()
            selection.addRange(range)
            this.ref.input.setSelectionRange(0, 999999)
        } else {
            this.ref.input.select()
        }

        try {
            document.execCommand('copy', false)
            this.showTooltip()
        } catch (err) {
            alert('Nastala chyba při kopírování', err)
        }
    }

    showTooltip() {
        this.ref.tooltip.classList.add("is-active")

        setTimeout(() => {
            this.ref.tooltip.classList.remove("is-active")
        }, 1000);
    }

    isIOS() {
        return navigator.userAgent.match(/ipad|iphone/i)
    }
}